import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  current: number;
  total: number;
  colorClass?: string;
}
export function ProgressBar({
  current,
  total,
  colorClass = 'bg-emerald-500'
}: ProgressBarProps) {
  const percentage = total > 0 ? current / total * 100 : 0;
  return <div className="w-full" data-id="element-172">
      <div className="flex items-center justify-between mb-1.5" data-id="element-173">
        <span className="text-xs font-medium text-slate-400" data-id="element-174">
          {current} of {total} complete
        </span>
        <span className="text-xs font-semibold text-slate-300" data-id="element-175">
          {Math.round(percentage)}%
        </span>
      </div>
      <div className="w-full h-2 bg-slate-700/60 rounded-full overflow-hidden" data-id="element-176">
        <motion.div className={`h-full rounded-full ${colorClass}`} initial={{
        width: 0
      }} animate={{
        width: `${percentage}%`
      }} transition={{
        duration: 0.5,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} data-id="element-177" />
      </div>
    </div>;
}